module.exports = __webpack_public_path__ + "media/images/bg_contents_pc-8ead3f3ca4837a7fc9ce0a6112f84bc4.png";